// Shared by every path to a web store — the click can happen on a page that never runs the install tracker.

import { chromiumBrowserBrand } from './browser_brand';

const CHROMIUM_STORE = 'chromium';
const SAFARI_STORE = 'safari';

const WENT_TO_STORE_KEY = 'unscreenWentToStore';

// The flag is also set on pages with no install tracker (the guides, getting-started step 3), where
// nothing consumes it. Expire it so a later navigation in the same tab — or a browser session restore,
// which sessionStorage survives — can't reload out of nowhere. Long, because the reload is what detects
// the install and people take their time at the store; the stray reload it allows costs far less.
const WENT_TO_STORE_MAX_AGE_MS = 4 * 60 * 60 * 1000;

// Read from the pre-paint classifier in _head_content, not the server, which serves one CDN-cached
// response to every browser. Non-Safari falls to chromium, matching the default download button.
export function storeParams() {
  if (document.documentElement.classList.contains('pd-store-safari')) return { store: SAFARI_STORE };
  const browserBrand = chromiumBrowserBrand();
  return browserBrand ? { store: CHROMIUM_STORE, browser_brand: browserBrand } : { store: CHROMIUM_STORE };
}

// Throws when storage is blocked; losing attribution is fine, breaking the page isn't.
export function markWentToStore() {
  try {
    sessionStorage.setItem(WENT_TO_STORE_KEY, String(Date.now()));
  } catch {
    // See above.
  }
}

export function wentToStore() {
  try {
    const markedAt = Number(sessionStorage.getItem(WENT_TO_STORE_KEY));
    if (!markedAt) return false;
    if (Date.now() - markedAt <= WENT_TO_STORE_MAX_AGE_MS) return true;

    clearWentToStore();
    return false;
  } catch {
    return false;
  }
}

export function clearWentToStore() {
  try {
    sessionStorage.removeItem(WENT_TO_STORE_KEY);
  } catch {
    // See above.
  }
}
